(function(){
  // ───────── Cascadia Cart State ─────────
  // Single source of truth for cart data.
  // Both cascadia-cart.js and cascadia-sample-studio.js
  // read from this instead of fetching /cart.js independently.

  let cache = null;
  let fetchPromise = null;
  const productCache = new Map(); // handle -> Promise<productJSON|null>

  function trackCartEvent(eventName, params){
    params = params || {};
    if (typeof window.gtag !== 'function') return;
    try {
      gtag('event', eventName, Object.assign({}, params, { event_category: 'cart_friction' }));
    } catch(e) { /* never let tracking break the cart */ }
  }
  window.cascadiaTrack = trackCartEvent;

  window.addEventListener('error', function(e){
    trackCartEvent('js_error', { message: e.message, filename: e.filename, lineno: e.lineno });
  });
  window.addEventListener('unhandledrejection', function(e){
    trackCartEvent('js_error', { message: 'unhandled_rejection: ' + ((e.reason && e.reason.message) || e.reason) });
  });

  function getProduct(handle){
    if(productCache.has(handle)) return productCache.get(handle);
    const p = fetch('/products/' + handle + '.js')
      .then(r => r.json())
      .catch(() => null);
    productCache.set(handle, p);
    return p;
  }

  async function fetchCart(){
    // if a fetch is already in flight, wait for that one
    // rather than firing a duplicate request
    if(fetchPromise) return fetchPromise;
    fetchPromise = fetch('/cart.js')
      .then(r => r.json())
      .then(raw => {
        cache = transform(raw);
        fetchPromise = null;
        return cache;
      })
      .catch(e => {
        fetchPromise = null;
        throw e;
      });
    return fetchPromise;
  }

  function transform(raw){
    // find soap sample line
    const sampleLine = raw.items.find(
      i => i.properties && i.properties._sample === 'soap'
    ) || null;

    // find all reward lines by type
    const rewardLines = {};
    raw.items.forEach(i => {
      if(i.properties && i.properties._reward){
        rewardLines[i.properties._reward] = i;
      }
    });

    // collect all discount labels + amounts across all line items
    const savings = [];
// line-level discounts
raw.items.forEach(item => {
  (item.discounts || []).forEach(d => {
    if(!savings.find(s => s.title === d.title)){
      savings.push({ title: d.title, amount: d.amount });
    }
  });
});
// cart-level discount codes
(raw.cart_level_discount_applications || []).forEach(d => {
  if(!savings.find(s => s.title === d.title)){
    savings.push({ title: d.title, amount: d.total_allocated_amount });
  }
});

    return {
      total:       raw.total_price,
      itemCount:   raw.item_count,
      items:       raw.items,
      sampleLine,
      rewardLines,
      savings,
      raw          // keep raw available for anything that needs it
    };
  }

  // invalidate cache when cart changes
  // so next getState() call fetches fresh data
  function invalidate(){
    cache = null;
    fetchPromise = null;
  }

  async function addToCart(variantId, quantity, properties){
  const props = properties || {};

  const result = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: quantity || 1, properties: props }]
    })
  }).then(r => r.json());

  invalidate();
  document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
  document.dispatchEvent(new Event('ajaxProduct:added'));
  document.dispatchEvent(new CustomEvent('cart:open'));
  return result;
}

async function removeFromCart(lineKey){
  const result = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 })
  }).then(r => r.json());

  invalidate();
  document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
  return result;
}

async function updateQuantity(lineKey, quantity){
  const result = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: quantity })
  }).then(r => r.json());

  invalidate();
  document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
  return result;
}

async function applyDiscount(code){
  const result = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code })
  }).then(r => r.json());

  invalidate();
  document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
  return result;
}

  // public API
  window.cascadiaState = {
  getState:       async function(){ if(cache) return cache; return fetchCart(); },
  refresh:        async function(){ invalidate(); return fetchCart(); },
  invalidate:     invalidate,
  peek:           function(){ return cache; },
  addToCart:      addToCart,
  removeFromCart: removeFromCart,
  updateQuantity: updateQuantity,
  applyDiscount:  applyDiscount,
  getProduct:     getProduct
};

  // listen for cart change events and auto-invalidate
  document.addEventListener('cascadia:cart-changed', invalidate);
  document.addEventListener('ajaxProduct:added', invalidate);
  document.addEventListener('cart:updated', invalidate);

  console.log('[cascadia state] ready');
})();